import firebase from 'firebase';
import 'firebase/firestore';

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DB_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGE_SENDER_ID,
};

// Date issue fix according to Firebase
const settings = {
  timestampsInSnapshots: true,
};

const FirebaseApp = firebase.initializeApp(firebaseConfig); // initalize
const db = FirebaseApp.database(); // firebase Database
const auth = FirebaseApp.auth(); // firebase authentication
const storage = FirebaseApp.storage(); // firebae storage
const fireStoreDB = FirebaseApp.firestore(); // firestore

fireStoreDB.settings(settings);

export default {
  db,
  auth,
  fireStoreDB,
  storage,
};
